/**
 * O relógio do topo — hora, minuto e segundo no FUSO DO WORKSPACE.
 *
 * Pedido do dono (06/10): em vez de escrever "o dia vira no fuso X" em cada tela, mostrar a
 * hora andando. Quem abre o painel vê de qual "agora" os números estão falando; se a hora
 * estiver errada para ele, o toque leva a Configurações, onde o fuso se troca.
 */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router';
import { Clock } from 'lucide-react';

export function RelogioDoWorkspace({
  timezone,
  configuracoesHref,
}: {
  timezone: string;
  configuracoesHref: string;
}) {
  const [agora, setAgora] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setAgora(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const formato = useMemo(() => {
    try {
      return new Intl.DateTimeFormat('pt-BR', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });
    } catch {
      // Fuso que o navegador não conhece: melhor a hora local que a tela quebrada.
      return new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });
    }
  }, [timezone]);
  const hora = formato.format(agora);

  return (
    <Link
      to={configuracoesHref}
      aria-label={`Agora são ${hora}. Trocar o fuso horário em Configurações.`}
      title="Hora do seu workspace. Toque para trocar o fuso em Configurações."
      className="nums inline-flex shrink-0 items-center gap-1 rounded-pill px-1.5 py-1 text-xs font-medium tabular-nums text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Clock aria-hidden="true" className="hidden size-3.5 sm:block" />
      <time>{hora}</time>
    </Link>
  );
}
